import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { EXPERIENCES, IMG } from "../data/content";
import { track } from "../lib/api";

export default function Experiences() {
  return (
    <main>
      <PageHero
        eyebrow="Signature Experiences"
        title="Choose the Experience You Want to Create"
        description="Eight signature worlds — from celebrity-led appearances to arena concerts and private VIP celebrations. Each one conceptualised, coordinated and delivered with precision."
        image={IMG.crowd}
      />
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 grid sm:grid-cols-2 gap-6">
          {EXPERIENCES.map((x, i) => (
            <Reveal key={x.slug} delay={(i % 2) * 0.08}>
              <Link
                to={`/experiences/${x.slug}`}
                onClick={() => track("service_view", { service: x.slug })}
                className="group relative block overflow-hidden border border-[#C9A55C]/15 h-[420px]"
                data-testid={`experiences-card-${x.slug}`}
              >
                <img src={x.image} alt={x.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#070708] via-[#070708]/30 to-transparent" />
                <div className="absolute bottom-0 p-8">
                  <p className="text-[0.6rem] tracking-[0.35em] text-[#C9A55C] uppercase">{String(i + 1).padStart(2, "0")}</p>
                  <h2 className="font-display text-2xl sm:text-3xl text-[#F3EEE5] mt-2 group-hover:text-[#C9A55C] transition-colors duration-300">{x.title}</h2>
                  <p className="font-accent italic text-[#A9ABB2] mt-1">{x.tagline}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <Marquee />
    </main>
  );
}
